<template>
  <div class="container mt-4">
    <h4>Crear Precio Competencia</h4>

    <form @submit.prevent="submit" class="mt-3">
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label>Pais</label>
            <input
              v-model="form.pais"
              class="form-control"
              placeholder="Pais"
              required
            />
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label>Brand</label>
            <input
              v-model="form.brand"
              class="form-control"
              placeholder="Brand"
              required
            />
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label>SKU</label>
            <input
              v-model="form.sku_name"
              class="form-control"
              placeholder="SKU name"
              required
            />
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-md-3">
          <div class="form-group">
            <label>SKU ID</label>
            <input v-model="form.sku_id" class="form-control" required />
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label>Precio USD / caja</label>
            <input
              type="number"
              step="0.01"
              min="0"
              v-model.number="form.precio_usd_caja"
              @input="normalizeNonNegative('precio_usd_caja')"
              class="form-control"
              required
            />
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label>Precio USD / KG</label>
            <input
              type="number"
              step="0.01"
              min="0"
              v-model.number="form.precio_usd_kg"
              @input="normalizeNonNegative('precio_usd_kg')"
              class="form-control"
              required
            />
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label>Category</label>
            <input
              v-model="form.category"
              class="form-control"
              placeholder="Category"
              required
            />
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-12 d-flex gap-2">
          <button class="btn-green" type="submit" :disabled="isSubmitting">
            {{ isSubmitting ? "Guardando..." : "Guardar" }}
          </button>
          <button class="btn-white" type="button" @click="cancel">
            Cancelar
          </button>
        </div>
      </div>
    </form>

    <vue-basic-alert ref="alert" :duration="300" :closeIn="1000000" />
  </div>
</template>

<script setup>
import { reactive, ref } from "vue";
import axios from "axios";
import { useRouter } from "vue-router";

const router = useRouter();
const alert = ref(null);
const isSubmitting = ref(false);

const form = reactive({
  pais: "",
  brand: "",
  sku_id: "",
  sku_name: "",
  precio_usd_caja: null,
  precio_usd_kg: null,
  category: "",
});

function showAlert(type, title, message) {
  if (alert.value && alert.value.showAlert) {
    alert.value.showAlert(type, message, title, {
      iconSize: 35,
      iconType: "solid",
      position: "top right",
    });
  }
}

function hasValue(value) {
  if (value === null || value === undefined) return false;
  if (typeof value === "string") return value.trim() !== "";
  return true;
}

function validateRequiredForm() {
  const requiredValues = [
    form.pais,
    form.brand,
    form.sku_name,
    form.sku_id,
    form.precio_usd_caja,
    form.precio_usd_kg,
    form.category,
  ];

  return requiredValues.every(hasValue);
}

function hasNegativeValues() {
  return [form.precio_usd_caja, form.precio_usd_kg]
    .some((value) => Number(value) < 0);
}

function normalizeNonNegative(field) {
  if (Number(form[field]) < 0) {
    form[field] = 0;
  }
}

const submit = async () => {
  if (isSubmitting.value) return;

  if (!validateRequiredForm()) {
    showAlert("error", "Campos obligatorios", "Todos los campos son requeridos.");
    return;
  }

  if (hasNegativeValues()) {
    showAlert("error", "Valor inválido", "No se permiten números menores a 0.");
    return;
  }

  isSubmitting.value = true;

  try {
    const payload = {
      pais: form.pais,
      brand: form.brand,
      sku_name: form.sku_name,
      sku_id: form.sku_id,
      precio_usd_caja: form.precio_usd_caja,
      precio_usd_kg: form.precio_usd_kg,
      category: form.category,
    };

    const res = await axios.post("/pricing/createCompetitionPrice", payload);
    if (res.data && res.data.error === false) {
      showAlert(
        "success",
        "Éxito",
        res.data.message || "Precio creado correctamente",
      );
      setTimeout(() => {
        router.push({ name: "pricing-precios-competencia" });
      }, 1200);
    } else {
      showAlert(
        "error",
        "Error",
        res.data.message || "No se pudo crear el precio",
      );
      isSubmitting.value = false;
    }
  } catch (err) {
    const message = err?.response?.data?.message || "Error al crear el precio";
    showAlert("error", "Error", message);
    isSubmitting.value = false;
  }
};

const cancel = () => {
  router.back();
};
</script>

<style scoped>
.btn-green {
  margin-right: 0.5rem;
}
</style>
